import { trackingControlUI } from '../utils';

export default class HandleControlVideoSwiper {
  constructor() {
    this.classes = {
      pause: 'pause',
      activeSound: 'active-sound',
      swiperActive: 'swiper-slide-active',
      btnControlSound: 'btn-control-sound',
      isClickPause: 'is-click-pause',
      btnPlayPause: 'btn-play-pause',
      textControl: 'text-control',
      itemGallery: '.item-gallery-item',
      iframeSection: '.iframe-full-section',
      dataKaltura: 'data-kaltura',
    };

    this.tags = {
      iframe: 'iframe, .kaltura-player-container',
    };

    this.texts = {
      youtubeCom: 'youtube.com',
      youtuBe: 'youtu.be',
      vimeoCom: 'vimeo.com',
    };
  }

  handleVideoSwiper(e, timeOut) {
    const $swiperActive = $(e.el).find(`.${this.classes.swiperActive}`);
    const $slideItem = $swiperActive.find(this.tags.iframe);
    const url = $slideItem.attr('src');
    if ($slideItem.length) {
      const $controlSound = $swiperActive.find(`.${this.classes.btnControlSound}`);
      setTimeout(() => {
        this.handlePausePlayVideo($swiperActive, $slideItem, url);
        if ($(window).innerWidth() > 1199) {
          this.handleMuteVideo($controlSound, $slideItem, url);
        }
      }, timeOut || 0);
    }
  }

  handlePausePlayVideo($swiperActive, $slideItem, url) {
    if (!$swiperActive.find(`.${this.classes.isClickPause}`).length) {
      if (url) {
        if (url.indexOf(this.texts.youtubeCom) !== -1 || url.indexOf(this.texts.youtuBe) !== -1) {
          $slideItem[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        }
        if (url.toLowerCase().indexOf(this.texts.vimeoCom) !== -1) {
          $slideItem[0].contentWindow.postMessage('{"method":"play"}', '*');
        }
      } else {
        const indexS = Number($swiperActive.find(this.classes.iframeSection).attr(this.classes.dataKaltura)) - 2;
        window.listVideoPopup[indexS].play();
      }
      $swiperActive.find(`.${this.classes.btnPlayPause}`).removeClass('pause').find(`.${this.classes.textControl}`).text('Pause');
    }
  }

  eventClickButtonPlayPauseVideo(event) {
    const $elm = $(event.currentTarget);
    if ($elm.hasClass(this.classes.pause)) {
      this.playVideo($elm);
      $elm.removeClass(this.classes.isClickPause);
      trackingControlUI($elm, 'play video');
    } else {
      this.pauseVideo($elm);
      $elm.addClass(this.classes.isClickPause);
      trackingControlUI($elm, 'pause video');
    }
  }

  eventClickButtonMuteUnmuteVideo(event) {
    const $elm = $(event.currentTarget);
    if ($elm.hasClass(this.classes.activeSound)) {
      this.mutedVideo($elm);
      trackingControlUI($elm, 'mute video');
    } else {
      this.unMuteVideo($elm);
      trackingControlUI($elm, 'unmute video');
    }
  }

  mutedVideo($elm) {
    const $swiperActive = $elm.parents(`.${this.classes.swiperActive}`);
    const $slideItem = $swiperActive.find(this.tags.iframe);
    const url = $slideItem.attr('src');
    if (url) {
      if (url.indexOf(this.texts.youtubeCom) !== -1 || url.indexOf(this.texts.youtuBe) !== -1) {
        $slideItem[0].contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
      }
      if (url.toLowerCase().indexOf(this.texts.vimeoCom) !== -1) {
        $slideItem[0].contentWindow.postMessage('{"method":"setVolume","value":"0"}', '*');
      }
    } else {
      const indexS = Number($elm.parents(this.classes.itemGallery).find(this.classes.iframeSection).attr(this.classes.dataKaltura)) - 2;
      if (window.listVideoPopup) {
        window.listVideoPopup[indexS].muted = true;
      }
    }
    $elm.removeClass(this.classes.activeSound);
  }

  unMuteVideo($elm) {
    const $swiperActive = $elm.parents(`.${this.classes.swiperActive}`);
    const $slideItem = $swiperActive.find(this.tags.iframe);
    const url = $slideItem.attr('src');
    if (url) {
      if (url.indexOf(this.texts.youtubeCom) !== -1 || url.indexOf(this.texts.youtuBe) !== -1) {
        $slideItem[0].contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
      }
      if (url.toLowerCase().indexOf(this.texts.vimeoCom) !== -1) {
        $slideItem[0].contentWindow.postMessage('{"method":"setVolume","value":"1"}', '*');
      }
    } else {
      const indexS = Number($elm.parents(this.classes.itemGallery).find(this.classes.iframeSection).attr(this.classes.dataKaltura)) - 2;
      window.listVideoPopup[indexS].muted = false;
    }
    $elm.addClass(this.classes.activeSound);
  }

  playVideo($elm) {
    const $swiperActive = $elm.parents(`.${this.classes.swiperActive}`);
    const $slideItem = $swiperActive.find(this.tags.iframe);
    const url = $slideItem.attr('src');
    if (url) {
      if (url.indexOf(this.texts.youtubeCom) !== -1 || url.indexOf(this.texts.youtuBe) !== -1) {
        $slideItem[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
      }
      if (url.toLowerCase().indexOf(this.texts.vimeoCom) !== -1) {
        $slideItem[0].contentWindow.postMessage('{"method":"play"}', '*');
      }
    } else {
      const indexS = Number($elm.parents(this.classes.itemGallery).find(this.classes.iframeSection).attr(this.classes.dataKaltura)) - 2;
      window.listVideoPopup[indexS].play();
    }
    $elm.parents(`.${this.classes.swiperActive}`).find('.button-play-video-mb').addClass('opacity-0');
    $elm.removeClass(this.classes.pause).find(`.${this.classes.textControl}`).text('Pause');
  }

  pauseVideo($elm) {
    const $swiperActive = $elm.parents(`.${this.classes.swiperActive}`);
    const $slideItem = $swiperActive.find(this.tags.iframe);
    const url = $slideItem.attr('src');
    if (url) {
      if (url.indexOf(this.texts.youtubeCom) !== -1 || url.indexOf(this.texts.youtuBe) !== -1) {
        $slideItem[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      }
      if (url.toLowerCase().indexOf(this.texts.vimeoCom) !== -1) {
        $slideItem[0].contentWindow.postMessage('{"method":"pause"}', '*');
      }
    } else {
      const indexS = Number($elm.parents(this.classes.itemGallery).find(this.classes.iframeSection).attr(this.classes.dataKaltura)) - 2;
      window.listVideoPopup[indexS].pause();
    }
    $elm.parents(`.${this.classes.swiperActive}`).find('.button-play-video-mb').removeClass('opacity-0');
    $elm.addClass(this.classes.pause).find(`.${this.classes.textControl}`).text('Play');
  }

  handleMuteVideo($controlSound, $slideItem, url) {
    if (window.mutedVideo === false && !$controlSound.hasClass(this.classes.activeSound)) {
      this.handleMute(url, $slideItem, $controlSound);
    } else {
      this.handleUnMute(url, $slideItem, $controlSound);
    }
  }

  handleMute(url, $slideItem, $controlSound) {
    if (url) {
      if (url.indexOf(this.texts.youtubeCom) !== -1 || url.indexOf(this.texts.youtuBe) !== -1) {
        $slideItem[0].contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
      }
      if (url.toLowerCase().indexOf(this.texts.vimeoCom) !== -1) {
        $slideItem[0].contentWindow.postMessage('{"method":"setVolume","value":"0"}', '*');
      }
    } else {
      const indexS = Number($slideItem.parents(this.classes.itemGallery).find(this.classes.iframeSection).attr(this.classes.dataKaltura)) - 2;
      window.listVideoPopup[indexS].muted = true;
    }
    $controlSound.removeClass(this.classes.activeSound);
  }

  handleUnMute(url, $slideItem, $controlSound) {
    if (url) {
      if (url.indexOf(this.texts.youtubeCom) !== -1 || url.indexOf(this.texts.youtuBe) !== -1) {
        $slideItem[0].contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
      }
      if (url.toLowerCase().indexOf(this.texts.vimeoCom) !== -1) {
        $slideItem[0].contentWindow.postMessage('{"method":"setVolume","value":"1"}', '*');
      }
    } else {
      const indexS = Number($slideItem.parents(this.classes.itemGallery).find(this.classes.iframeSection).attr(this.classes.dataKaltura)) - 2;
      window.listVideoPopup[indexS].muted = false;
    }
    $controlSound.addClass(this.classes.activeSound);
  }
}